// src/constants/demoUsers.js
import { FULL_PERMISSIONS } from './appModules';

// Shared demo accounts shown on the login screen — used for local demo sessions when the API is unavailable.
/** `role` must match API `user_role_enum` (lowercase). `roleLabel` is for UI only. */
export const DEMO_USERS = [
  { email: 'director@vahd.gov.in', password: 'Admin@123', name: 'Dr. K. Suresh Kumar', role: 'director', roleLabel: 'Director', initials: 'SK' },
  { email: 'dvaho@vahd.gov.in',    password: 'Admin@123', name: 'Dr. Padma Lakshmi',   role: 'dvaho',    roleLabel: 'DVAHO',    initials: 'PL' },
  { email: 'vo@vahd.gov.in',       password: 'Admin@123', name: 'Dr. Ramesh Naidu',    role: 'vo',       roleLabel: 'Vet Officer', initials: 'RN' },
];

/**
 * Permission set for a Veterinary Officer (VO) demo — can view clinical and HRMS
 * but cannot access admin-level sections.
 */
const VO_PERMISSIONS = {
  // Nav group gates
  dashboard:  { view: true },
  clinical:   { view: true },
  hrms:       { view: true },
  reports:    { view: true },

  // Individual modules
  dashboard_page:          { view: true },
  daily_progress:          { view: true },
  clinical_cases:          { view: true, add: true, edit: true },
  clinical_vaccinations:   { view: true, add: true, edit: true },
  clinical_deworming:      { view: true, add: true, edit: true },
  clinical_ai_service:     { view: true, add: true, edit: true },
  fodder:                  { view: true, add: true },
  hrms_overview:           { view: true },
  hrms_employees:          { view: true },
  hrms_attendance:         { view: true, add: true },
  hrms_attendance_report:  { view: true },
  hrms_leave:              { view: true, add: true },
  hrms_farmers:            { view: true },
  reports:                 { view: true },
};

/** @returns {typeof DEMO_USERS[0] | null} */
export function findDemoCredential(email, password) {
  const e = (email || '').trim().toLowerCase();
  const row = DEMO_USERS.find(u => u.email.toLowerCase() === e && u.password === password);
  return row || null;
}

export function buildDemoSessionUser(demo) {
  // Director gets full access; DVAHO gets full access; VO gets restricted access
  const permissions = (demo.role === 'director' || demo.role === 'admin' || demo.role === 'dvaho')
    ? FULL_PERMISSIONS
    : VO_PERMISSIONS;

  return {
    id: `demo-${demo.email.replace(/[^a-z0-9]+/gi, '-')}`,
    email: demo.email,
    name: demo.name,
    role: demo.role,
    permissions,
  };
}
